import { JourneyRoute } from '@cash-web/shared-journey-util-main'

import { JourneyNotFound } from './JourneyNotFound'

export const journeyRoutes = [
  {
    id: 'journey-idle',
    trackingName: 'Journey Idle',
    path: '/',
    element: null,
  },
  // this is a wildcard route that will match any route that is not found,
  // this must be the last route otherwise it will match everything before going to the next route match
  {
    id: 'journey-not-found',
    trackingName: 'Journey Not Found',
    path: '*',
    element: <JourneyNotFound />,
  },
] as const satisfies JourneyRoute[]
